export enum PanDirection {
	UpLeft = "up-left",
	Up = "up",
	UpRight = "up-right",
	Left = "left",
	Right = "right",
	DownLeft = "down-left",
	Down = "down",
	DownRight = "down-right"
}